// MUI
import { Stack, Typography } from "@mui/material";

// Assets
import { ReactComponent as Delivered } from "@/assets/icons/dataPages/FinanceManagement/cit/delivered-ball-icon.svg";
import { ReactComponent as ClosedBallIcon } from "@/assets/icons/dataPages/FinanceManagement/cit/closed-ball-icon.svg";
import { ReactComponent as FinalizedBallIcon } from "@/assets/icons/dataPages/FinanceManagement/cit/finalized-ball-icon.svg";

export default function MultiBarChartGraphLegend() {
	return (
		<Stack spacing={0} alignSelf={"flex-end"}>
			<Stack direction={"row"} alignItems={"center"} spacing={1.25}>
				<Delivered />{" "}
				<Typography component={"span"} className={"!font-sans !text-sm !text-default !font-normal"}>
					Delivered
				</Typography>
			</Stack>
			<Stack direction={"row"} alignItems={"center"} spacing={1.25}>
				<ClosedBallIcon />{" "}
				<Typography component={"span"} className={"!font-sans !text-sm !text-default !font-normal"}>
					Closed
				</Typography>
			</Stack>
			<Stack direction={"row"} alignItems={"center"} spacing={1.25}>
				<FinalizedBallIcon />{" "}
				<Typography component={"span"} className={"!font-sans !text-sm !text-default !font-normal"}>
					Finalized
				</Typography>
			</Stack>
		</Stack>
	);
}
